import { render, staticRenderFns } from "./ErfolgWingComponent.vue?vue&type=template&id=5340a2f4&scoped=true&"
import script from "./ErfolgWingComponent.vue?vue&type=script&lang=ts&"
export * from "./ErfolgWingComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ErfolgWingComponent.vue?vue&type=style&index=0&id=5340a2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5340a2f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VFlex,VIcon,VLayout})
